import {
  addProfileDataComplete,
  addProfileDataError,
  backOfficeValidationComplete,
  debitCardInitRegisterComplete,
  debitCardInitRegisterError,
  debitCardPreRegisterComplete,
  debitCardPreRegisterError,
  nicValidateComplete,
  nicValidateError,
  onboardingOtpConfirmComplete,
  onboardingOtpConfirmError,
  onboardingOtpResendComplete,
  onboardingOtpResendError,
  onboardingUsernameValidateComplete,
  onboardingUsernameValidateError,
} from "../_actions/onboarding.actions";
import { onboardingConstants } from "../_constants";

("use strict");

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import {
  ajaxError,
  payloadEncryptionFail,
  payloadEncryptionSuccess,
} from "../_actions";

export const nicValidateEpic = (actions$) =>
  actions$.pipe(
    ofType(onboardingConstants.NIC_VALIDATE_REQUEST),
    mergeMap((action) => {
      const finalPayload = { ...action.payload };
      delete finalPayload.restoreData;
      return ajax
        .post("/api/auth/validate-nic", finalPayload, getRequestHeader("POST"))
        .pipe(
          map((ajaxResponse) => nicValidateComplete(ajaxResponse.response)),
          catchError((error) => of(nicValidateError(error), ajaxError(error))),
        );
    }),
  );

export const debitCardPreRegisterEpic = (actions$) =>
  actions$.pipe(
    ofType(onboardingConstants.DEBIT_CARD_PRE_REGISTER_REQUEST),
    mergeMap(async (action) => {
      try {
        const finalPayload = { ...action.payload };
        delete finalPayload.restoreData;
        const payload = await from(
          payloadFormatter(
            { ...finalPayload },
            "/api/auth/debit-card-pre-register",
          ),
        ).toPromise();
        return payloadEncryptionSuccess(payload, action.payload);
      } catch (error) {
        return payloadEncryptionFail(error);
      }
    }),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/auth/debit-card-pre-register",
          { ...action.encryptedPayload, fingerPrint: action.payload.uid },
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            debitCardPreRegisterComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(debitCardPreRegisterError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const debitCardInitRegisterEpic = (actions$) =>
  actions$.pipe(
    ofType(onboardingConstants.DEBIT_CARD_INIT_REGISTER_REQUEST),
    mergeMap((action) => {
      const finalPayload = { ...action.payload };
      delete finalPayload.restoreData;
      return ajax
        .post(
          "/api/auth/debit-card-init-register",
          finalPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            debitCardInitRegisterComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(debitCardInitRegisterError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const onboardingOtpResendEpic = (actions$) =>
  actions$.pipe(
    ofType(onboardingConstants.ONBOARDING_OTP_RESEND_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/auth/onboarding-otp-resend",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            onboardingOtpResendComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(onboardingOtpResendError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const onboardingOtpConfirmEpic = (actions$) =>
  actions$.pipe(
    ofType(onboardingConstants.ONBOARDING_OTP_CONFIRM_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/auth/onboarding-otp-confirm",
          { ...action.payload, fingerPrint: action.payload.uid },
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            onboardingOtpConfirmComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(onboardingOtpConfirmError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const onboardingUsernameValidateEpic = (actions$) =>
  actions$.pipe(
    ofType(onboardingConstants.USERNAME_VALIDATE_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/auth/onboarding-username-validate",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            onboardingUsernameValidateComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(onboardingUsernameValidateError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const backOfficeValidationEpic = (actions$) =>
  actions$.pipe(
    ofType(onboardingConstants.BACKOFFICE_VALIDATION_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/auth/back-office-validate",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            backOfficeValidationComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(debitCardInitRegisterError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const addProfileDataEpic = (actions$) =>
  actions$.pipe(
    ofType(onboardingConstants.ADD_PROFILE_INFO_REQUEST),
    mergeMap(async (action) => {
      try {
        const payload = await from(
          payloadFormatter(action.payload, "/api/auth/add-profile-info"),
        ).toPromise();
        return payloadEncryptionSuccess(payload, action.payload);
      } catch (error) {
        return payloadEncryptionFail(error);
      }
    }),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/auth/add-profile-info",
          action.encryptedPayload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => addProfileDataComplete(ajaxResponse.response)),
          catchError((error) =>
            of(addProfileDataError(error), ajaxError(error)),
          ),
        );
    }),
  );
